import CitiesList from './CitiesList.js';

const initCitiesList = () => {
  const elements = Array.from(document.querySelectorAll('[data-component="cities-list"]'));

  elements.forEach((element) => {
    new CitiesList(element);
  });
};

export default initCitiesList;
